import Component from './Component';
import Armature from '../Prototype/Armature';
import * as PIXI from 'pixi.js';

export enum DragonbonesAnimationEvent {
    PLAY = 'play',
    COMPLETE = 'complete',
    FADE_IN = 'fade_in',
}

export default class DragonbonesComponent extends Component<
    PIXI.Container,
    Armature
> {
    public dragonbonesName: string = undefined;
    public armatureName: string = undefined;
    public animationName: string = undefined;
    public timescale: number = 1;
    public playOnStart: boolean = true;
    public progress: number = 0;
}
